// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_vgD5Z","tab-part-title":"tab-part-title_bEUou"};